import { render, staticRenderFns } from "./SupplierImage.vue?vue&type=template&id=abf6928a&"
import script from "./SupplierImage.vue?vue&type=script&lang=js&"
export * from "./SupplierImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports